import { HighlightableTextOverlayProps } from './HighlightableTextOverlay.props';
import { HighlightableTextOverlayActionButton } from './HighlightableTextOverlay.styles';

const HighlightableTextOverlay = ({ selectionReference, highlightActions }: HighlightableTextOverlayProps) => (
  <>
    {Array.from(selectionReference.rects).map(rect => (
      <div
        key={`${rect.top}-${rect.left}-${rect.width}-${rect.height}`}
        // not moving to styles file since there are multiple props
        style={{
          position: 'fixed',
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
          backgroundColor: 'rgba(0, 123, 255, 0.3)',
          border: '1px solid rgba(0, 123, 255, 0.6)',
          pointerEvents: 'none',
          zIndex: 9998,
          transition: 'all 0.15s ease',
        }}
      />
    ))}
    {highlightActions.map(action => (
      <HighlightableTextOverlayActionButton
        key={action.label}
        type="button"
        tabIndex={-1}
        onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onClick={() => {
          const selectedText = selectionReference.text;
          const { startIndex } = selectionReference;
          const { endIndex } = selectionReference;

          action.action({ selectedText, startIndex, endIndex });

          window.getSelection()?.removeAllRanges();
        }}
        sx={{
          top: Math.max(8, selectionReference.rect.top - 38),
          left: Math.min(
            window.innerWidth - 140,
            Math.max(8, selectionReference.rect.left + selectionReference.rect.width / 2 - 60)
          ),
          transition: 'all 0.15s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          },
        }}>
        {action.label}
      </HighlightableTextOverlayActionButton>
    ))}
  </>
);


export default HighlightableTextOverlay;